import menusGeral from '@/navigation/vertical/modules/geral'
import menusListings from '@/navigation/vertical/modules/listings'
import menusCRM from '@/navigation/vertical/modules/crm'
import menusSales from '@/navigation/vertical/modules/sales'
import menusFinancial from '@/navigation/vertical/modules/financial'

export default [...menusGeral, ...menusListings, ...menusCRM, ...menusSales, ...menusFinancial]
